export enum ActivePageEnum {
  SETTINGS = 'Settings',
  WORKFLOW = 'Workflow',
  USER_PREFERENCE = 'UserPreference',
  SMS = 'Sms',
  EMAIL = 'Email',
  IN_APP = 'in_app',
  PUSH = 'Push',
  CHAT = 'Chat',
  TRIGGER_SNIPPET = 'TriggerSnippet',
}
